/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_Name_StudyInputs */

const en_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Study`)
};

const ar_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دراسة`)
};

const de_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studieren`)
};

const es_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiar`)
};

const fr_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étudier`)
};

const it_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studia`)
};

const ja_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`勉強`)
};

const ko_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공부`)
};

const pt_br_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudar`)
};

const ru_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учёба`)
};

const th_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียน`)
};

const tr_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders`)
};

const zh_cn_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习`)
};

const zh_tw_daily_paywall_allow_list_name_study = /** @type {(inputs: Daily_Paywall_Allow_List_Name_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讀書`)
};

/**
* | output |
* | --- |
* | "Study" |
*
* @param {Daily_Paywall_Allow_List_Name_StudyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_name_study = /** @type {((inputs?: Daily_Paywall_Allow_List_Name_StudyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_Name_StudyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_name_study(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_name_study(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_name_study(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_name_study(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_name_study(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_name_study(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_name_study(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_name_study(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_name_study(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_name_study(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_name_study(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_name_study(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_name_study(inputs)
	return zh_tw_daily_paywall_allow_list_name_study(inputs)
});